import React from "react";
import Level from "../../components/Level";
import TazaLogo from "../../assets/LockLevel.png"



function Pruebas(){
    return(
        <div>
           <Level  img = {TazaLogo} borderColor="#BDBDBD" number="2" backgroundColor="#BDBDBD" text="Expresiones 2" navigate="/Game"  />
        </div>
    )
}

export default Pruebas;